var $6efa0e119f396950$exports = {};
$6efa0e119f396950$exports = {
  "calendar": "\u041A\u0430\u043B\u0435\u043D\u0434\u0430\u0440\u044C",
  "day": "\u0434\u0435\u043D\u044C",
  "dayPeriod": "AM/PM",
  "endDate": "\u0414\u0430\u0442\u0430 \u043E\u043A\u043E\u043D\u0447\u0430\u043D\u0438\u044F",
  "era": "\u044D\u0440\u0430",
  "hour": "\u0447\u0430\u0441",
  "minute": "\u043C\u0438\u043D\u0443\u0442\u0430",
  "month": "\u043C\u0435\u0441\u044F\u0446",
  "second": "\u0441\u0435\u043A\u0443\u043D\u0434\u0430",
  "selectedDateDescription": function selectedDateDescription(args) {
    return "\u0412\u044B\u0431\u0440\u0430\u043D\u043D\u0430\u044F \u0434\u0430\u0442\u0430: ".concat(args.date);
  },
  "selectedRangeDescription": function selectedRangeDescription(args) {
    return "\u0412\u044B\u0431\u0440\u0430\u043D\u043D\u044B\u0439 \u0434\u0438\u0430\u043F\u0430\u0437\u043E\u043D: \u0441 ".concat(args.startDate, " \u043F\u043E ").concat(args.endDate);
  },
  "selectedTimeDescription": function selectedTimeDescription(args) {
    return "\u0412\u044B\u0431\u0440\u0430\u043D\u043D\u043E\u0435 \u0432\u0440\u0435\u043C\u044F: ".concat(args.time);
  },
  "startDate": "\u0414\u0430\u0442\u0430 \u043D\u0430\u0447\u0430\u043B\u0430",
  "timeZoneName": "\u0447\u0430\u0441\u043E\u0432\u043E\u0439 \u043F\u043E\u044F\u0441",
  "weekday": "\u0434\u0435\u043D\u044C \u043D\u0435\u0434\u0435\u043B\u0438",
  "year": "\u0433\u043E\u0434"
};
export { $6efa0e119f396950$exports as default };